import { createContext } from 'react'

interface IPermitionContext {
    menus: any[]
    rotinas: { id: string; descricao: string }[]
    isLoading?: boolean
    error?: unknown
    hasPermissions?: boolean
}

export const PermitionContext = createContext<IPermitionContext>({
    menus: [],
    rotinas: [],
    isLoading: false,
    error: undefined,
    hasPermissions: false,
})